var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNpIdea888712000000(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m50 31.25c-9.168 0-16.668 7.5-16.668 16.668 0 3.75 1.25 7.082 3.332 9.793 0 0 0.625 0.83203 0.83203 1.043 1.875 2.293 6.457 8.75 6.457 14.168h12.5c0-5.418 4.582-11.875 6.457-14.168 0.20703-0.20703 0.83203-1.043 0.83203-1.043 2.082-2.707 3.332-6.25 3.332-9.793-0.40625-9.168-7.9062-16.668-17.074-16.668z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.75 77.082h12.5v8.332h-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.668 45.832h12.5v4.168h-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.832 45.832h12.5v4.168h-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.121 22.871l2.9453 2.9453-8.8398 8.8398-2.9453-2.9453z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.918 14.582h4.168v12.5h-4.168z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.902 22.852l8.8398 8.8398-2.9453 2.9453-8.8398-8.8398z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpIdea888712000000);
export default __webpack_public_path__ + "static/media/np_idea_888712_000000.122b850fecf64ba3b93c96477c5c57e2.svg";
export { ForwardRef as ReactComponent };